module.exports = __webpack_public_path__ + "img/Sid_Momin.ee47569a.jpg";